import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * The answers the scoping form is allowed to send.
 *
 * Fetched from the backend rather than duplicated here, so the labels in the
 * form, in the team's alert email and in the dashboard can never drift apart.
 */
export function useScopingOptions() {
  const [options, setOptions] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let live = true;
    axios
      .get(`${API}/finance-function/options`)
      .then(({ data }) => {
        if (live) setOptions(data.options);
      })
      .catch(() => {
        if (live) setFailed(true);
      });
    return () => {
      live = false;
    };
  }, []);

  return { options, failed };
}

/** Posts one enquiry. Resolves to a reference, or throws a field-error map. */
export async function submitEnquiry(answers) {
  try {
    const { data } = await axios.post(`${API}/finance-function/enquiry`, answers);
    return data.reference;
  } catch (error) {
    const errors = error?.response?.data?.detail?.errors;
    if (errors) {
      const problem = new Error("validation");
      problem.fieldErrors = errors;
      throw problem;
    }
    throw error;
  }
}
